import React from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import mmmLogo from "../../../assets/images/mmm-white-logo.png";
import {
  footerLinks,
  footerSocialMediaLinks,
  TRACKING_FOOTER_OPTIONS,
} from "../../../constants";
import NavigationLinks from "../../generic-components/navigation-links";
import SocialMediaLinks from "../../generic-components/socialmedia-links";
import LogoButton from "../../generic-components/logo-btn";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const Footer = ({ organisation }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:900px)");

  const [firstColLinks, secondColLinks] = isTablet
    ? [footerLinks.slice(0, 4), footerLinks.slice(4)]
    : [footerLinks, []];

  const renderLinks = (links) =>
    links.map((val, index) => {
      const link =
        val.name === "Privacy Policy" && organisation?.privacy_policy_pdf
          ? organisation.privacy_policy_pdf
          : val.link;

      return (
        <NavigationLinks
          key={val.name + index}
          styleClass="footerlinks nav-links mt-0"
          link={link}
          name={val.name}
          trackingDetails={TRACKING_FOOTER_OPTIONS}
          newTab
        />
      );
    });

  return (
    <>
      <Box className="footer">
        <Container
          maxWidth={"none"}
          sx={{
            paddingRight: { md: "40px" },
            paddingLeft: { xs: "20px", md: "29px" },
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Box className="footer-content">
                <Stack
                  direction={{ md: "row", sm: "column" }}
                  justifyContent="space-between"
                  className="mb-30"
                  sx={{
                    marginBottom: {
                      md: "47px !important",
                    },
                  }}
                >
                  <Box className="footer-logo-container">
                    <LogoButton
                      name="MMM"
                      logoPath={mmmLogo}
                      trackingDetails={TRACKING_FOOTER_OPTIONS}
                      styleClass="footer-logo"
                    />
                  </Box>
                  <Stack
                    direction="column"
                    alignItems={{ md: "end", xs: "start" }}
                    justifyContent={{ md: "center" }}
                  >
                    <Typography
                      variant={isMobile ? "h6" : "h4"}
                      color="white"
                      fontWeight="600"
                      sx={{
                        fontSize: {
                          sm: "36px !important",
                          xs: "26px !important",
                        },
                        lineHeight: "40px",
                      }}
                      className={isTablet ? "mt-30" : ""}
                    >
                      Your platform{" "}
                      <span className="lighter-purple-v2">for prosperity</span>
                    </Typography>
                    <Stack
                      sx={{
                        flexWrap: "wrap",
                        justifyContent: {
                          md: "flex-end",
                          xs: "flex-start",
                        },
                        flexDirection: "row",
                        alignItems: { md: "center", xs: "flex-start" },
                        width: "100%",
                      }}
                      spacing={2.75}
                      gap={{ xs: "15%", md: 0 }}
                      justifyContent={{ md: "flex-end", xs: "flex-start" }}
                      className={isMobile ? "mt-20" : "mt-10"}
                    >
                      <Stack
                        flexDirection={{ xs: "column", md: "row" }}
                        alignItems={{ md: "flex-end", xs: "flex-start" }}
                        gap={{ xs: "12px", md: "22px" }}
                        spacing={1}
                      >
                        {renderLinks(firstColLinks)}
                      </Stack>

                      {secondColLinks.length > 0 && (
                        <Stack
                          flexDirection="column"
                          alignItems={{ md: "flex-end", xs: "flex-start" }}
                          spacing={1}
                          gap={{ xs: "12px" }}
                          marginTop={"0px !important"}
                        >
                          {renderLinks(secondColLinks)}
                        </Stack>
                      )}
                    </Stack>
                  </Stack>
                </Stack>
                <Divider style={{ background: "#3E394D" }} />
                <Stack
                  className={isTablet ? "mt-30" : "mt-18"}
                  direction={{
                    md: "row-reverse",
                    sm: "column",
                  }}
                  justifyContent="space-between"
                  spacing={{ md: 0, sm: 2, xs: 2 }}
                  alignItems={{ md: "center", sm: "left" }}
                >
                  <Stack
                    className="socialmedia"
                    direction="row"
                    spacing={2.75}
                    mt={2}
                  >
                    {footerSocialMediaLinks.map((val, index) => (
                      <SocialMediaLinks
                        link={val.link}
                        name={val.name}
                        iconPath={val.iconPath}
                        trackingDetails={TRACKING_FOOTER_OPTIONS}
                        key={index}
                      />
                    ))}
                  </Stack>
                  <Typography
                    color="white"
                    variant={isTablet ? "body2" : "body1"}
                    className={isTablet ? "mt-30" : ""}
                    sx={{
                      fontSize: {
                        xs: "13px !important",
                        md: "15px !important",
                      },
                      fontWeight: 400,
                      lineHeight: "100%",
                      paddingTop: {
                        md: "23px !important",
                      },
                    }}
                  >
                    © {new Date().getFullYear()}, AVC Wise Ltd (t/a My Money
                    Matters). All Rights reserved. Company Number 11406613
                  </Typography>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    organisation: state?.organisation?.organisation,
  };
};

Footer.propTypes = {
  organisation: PropTypes.object,
};

export default connect(mapStateToProps)(Footer);
